/**
 * @create date 2025-04-07 15:25:00
 * @modify date 2025-04-07 15:25:00
 */
import { PersonalCenterController } from './my/index';

export class MobilePersonalCenterController {
  /** @dec 留资跟踪 */
  PersonalCenterController = new PersonalCenterController();
}
